"use client";
import { useStore, observer } from "../../../../service/mobx";
import SearchFilterChip from ".";
import SearchMenu from "../../../../component/Menu/menus/Search";
import { OffIcon, OnIcon } from "../../../../component/Star";

export default observer(function FilterStars() {
  const { search, stars } = useStore();
  const param = "stars";
  const lists = {
    all: "All my stuff",
    ...Object.fromEntries(
      stars.lists.map(list => [list.name.toLowerCase(), list.name])
    )
  };

  return stars.show ? (
    <SearchFilterChip
      key={stars.map.size}
      param={param}
      disabled={stars.loading === false && stars.map.size === 0}
      StartIcon={search.filterStars ? OnIcon : OffIcon}
      options={lists}
      Menu={{
        sx: { menuList: { pt: 0 } },
        Component: () => (
          <SearchMenu
            filter="stars"
            param={param}
            items={Object.entries(lists)}
          />
        )
      }}
    />
  ) : null;
});
